// src/components/donation/donation-table.tsx
import { ColumnProps } from "antd/es/table";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { IDonation } from "../../../models/donation/response";
import { DonationTarget, getDonationTarget, getPeriodRatio, getDonationStatus } from "../../../models/donation/enum";

import Table from "../../general/table-components/table"; // ✅ استخدم نفس الجدول المخصص
import Space from "../../general/antd/space";
import ViewBtn from "../../general/table-components/actions/view-btn";

interface IProps {
  data: IDonation[];
  loading: boolean;
  total: number;
  page: number;
  pageSize: number;
  onPaginationChange: (page: number, pageSize: number) => void;
}

const DonationTable: React.FC<IProps> = ({
  data,
  loading,
  total,
  page,
  pageSize,
  onPaginationChange,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const columns: ColumnProps<IDonation>[] = [
    {
      title: t("id"),
      dataIndex: "id",
      align: "center",
      width: 80,
    },
    {
      title: t("donor_name"),
      render: (_, donation) => donation.donor?.fullName ?? "-",
      align: "center",
    },
    {
      title: t("target"),
      render: (_, donation) => t(getDonationTarget(donation.target as DonationTarget)),
      align: "center",
    },
    {
      title: t("target_name"),
      render: (_, donation) => {
        if (donation.targetModel && "name" in donation.targetModel) {
          return donation.targetModel.name;
        } else if (donation.targetModel && "firstName" in donation.targetModel) {
          return `${donation.targetModel.firstName} ${donation.targetModel.lastName}`;
        }
        return "-";
      },
      align: "center",
    },
    {
      title: t("donation_unit"),
      dataIndex: "donationUnit",
      align: "center",
    },
    {
      title: t("total_donation"),
      render: (_, record) => record ? record.count * record.donationUnit : "-",
      align: "center",
    },
    {
      title: t("currency"),
      dataIndex: "currency",
      align: "center",
    },
    {
      title: t("donation_type"),
      render: (_, record) => record?.periodRatio ? t("periodic") : t("non_periodic"),
      align: "center",
    },
    {
      title: t("period_ratio"),
      render: (_, record) => record?.periodRatio ? t(getPeriodRatio(record.periodRatio)) : "-",
      align: "center",
    },
    {
      title: t("status"),
      render: (_, record) => record?.status ? t(getDonationStatus(record.status)) : "-",
      align: "center",
    },
    {
      title: t("gift"),
      render: (val) => val ? "🎁" : "❌",
      dataIndex: "giftAble",
      align: "center",
    },
    {
      title: t("created_at"),
      dataIndex: "createdAt",
      render: (val) => new Date(val).toLocaleDateString(),
      align: "center",
    },
    {
      title: t("actions"),
      key: "actions",
      render: (_, record) => (
        <Space>
          <ViewBtn onClick={() => navigate(`details/${record.id}`)} />
        </Space>
      ),
      align: "center",
      width: 120,
    },
  ];

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={data}
      loading={loading}
      showPagination={true}
      scroll={{ x: 1200 }}
      total={total}
      page={page}
      pageSize={pageSize}
      onPaginationChange={onPaginationChange}
    />
  );
};

export default DonationTable;
